import {
  closeOverlay,
  openOverlay,
} from "./OverlayManager";

// NapflixOS Universal Search v9
// Runtime state foundation for OS-level search.
let searchState = {
  open: false,
  query: "",
  selectedIndex: 0,
  results: [],
  loading: false,
  error: null,
  openedAt: null,
};

const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((listener) => listener(searchState));
};

const syncSearchOverlay = () => {
  if (!searchState.open) {
    closeOverlay("napflix-search");
    return;
  }

  openOverlay({
    id: "napflix-search",
    type: "search",
    priority: 90,
    modal: true,
    focusTrap: false,
    payload: {
      query: searchState.query,
      selectedIndex: searchState.selectedIndex,
      resultsCount: searchState.results.length,
      loading: searchState.loading,
    },
  });
};

export function getSearchState() {
  return searchState;
}

export function setSearchState(partial) {
  const nextResults = partial.results ?? searchState.results;
  const maxIndex = Math.max(0, nextResults.length - 1);

  searchState = {
    ...searchState,
    ...partial,
    results: nextResults,
    selectedIndex: Math.min(
      maxIndex,
      Math.max(0, partial.selectedIndex ?? searchState.selectedIndex)
    ),
  };

  syncSearchOverlay();
  notifyListeners();
}

export function subscribeSearch(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function openSearch() {
  setSearchState({
    open: true,
    query: "",
    selectedIndex: 0,
    results: [],
    loading: false,
    error: null,
    openedAt: Date.now(),
  });
}

export function closeSearch() {
  setSearchState({
    open: false,
    query: "",
    selectedIndex: 0,
    results: [],
    loading: false,
    error: null,
    openedAt: null,
  });
}

export function toggleSearch() {
  if (searchState.open) {
    closeSearch();
    return;
  }

  openSearch();
}
